<template>
  <div class="flex h-full flex-col divide-y">
    <div class="">
      <template
        v-for="section in settingsSections"
        :key="section.id"
      >
        <component :is="section.component" />
      </template>
    </div>
  </div>
</template>

<script setup>
import SettingsGeneral from "@/components/SettingsGeneral.vue"
import SettingsMerchant from "@/components/SettingsMerchant.vue"
import SettingsDevice from "@/components/SettingsDevice.vue"
import SettingsVAT from "@/components/SettingsVAT.vue"
// import SettingsHospitality from "@/components/SettingsHospitality.vue"
import SettingsUnlinkedRefunds from "@/components/SettingsUnlinkedRefunds.vue"
import SettingsCharity from "@/components/SettingsCharity.vue"
import SettingsGratuity from "@/components/SettingsGratuity.vue"

const {
  // isHospitalityAvailable,
  hasSalesModule,
  hasDonationsModule,
  acquirer,
  evoConfig,
  isGratuityEnabled,
} = useTenant()

const settingsSections = computed(() => [
  {
    id: "general-settings",
    component: SettingsGeneral,
  },
  {
    id: "merchant-settings",
    component: SettingsMerchant,
  },
  ...(hasSalesModule.value
    ? [
        {
          id: "device-settings",
          component: SettingsDevice,
        },
      ]
    : []),

  ...(hasSalesModule.value
    ? [
        {
          id: "unlinked-refund-settings",
          component: SettingsUnlinkedRefunds,
        },
      ]
    : []),
  ...(hasSalesModule.value
    ? [
        {
          id: "vat-settings",
          component: SettingsVAT,
        },
      ]
    : []),
  ...(hasSalesModule.value &&
  isGratuityEnabled.value &&
  (acquirer.value !== "evo" ||
    (acquirer.value === "evo" &&
      evoConfig.value.gratuityIsAvailable))
    ? [
        {
          id: "gratuity-settings",
          component: SettingsGratuity,
        },
      ]
    : []),
  ...(hasDonationsModule.value
    ? [
        {
          id: "donation-settings",
          component: SettingsCharity,
        },
      ]
    : []),
])
</script>
